import { cloneDeep } from "lodash";
import config from "../config";

export class Customer {
    constructor(props){
        this.customerId = "_";
        this.discount = null;
        
        Object.assign(this, props);

        this.companyId = config?.operator?.companyId
    }

    /**
     * Get the discount value, falling back to system default if not set
     * @returns {number} - The discount percentage (0-100)
     */
    getDiscount() {
        // If customer has a specific discount value, use it
        if (this.discount !== null && this.discount !== undefined) {
            return this.discount;
        }
        
        return 0;
    }

    isValid() {
        return true
    }

    clone() {
        return new Customer(cloneDeep(this))
    }
}